/* eslint-disable jsx-quotes */
import React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';

import { logout } from './header.action';
import { changeRedirectToUsers } from '../users/users.actions';
import logo from '../../images/febracis_transparent.png';
import routes from '../../utils/routes';
import './header.css';
import defaultPhoto from '../../images/default.png';

class Header extends React.Component {
    constructor() {
        super();

        this.state = {
            avatarExpanded: false,
        };

        this.listenClick = this.listenClick.bind(this);
    }

    componentDidMount() {
        window.addEventListener('click', this.listenClick, true);
    }

    componentWillUnmount() {
        window.removeEventListener('click', this.listenClick, true);
    }

    listenClick(event) {
        if (!event.target.matches('.avatar-img')) {
            this.setState({ avatarExpanded: false });
        }
    }

    logout() {
        this.props.logout();
    }

    render() {
        const { avatarExpanded } = this.state;
        const {
            photoUrl,
            location,
            firstName,
            secondName,
            changeRedirectToUsers,
        } = this.props;

        const photo = photoUrl == null ? defaultPhoto : photoUrl;
        const fullName =
            firstName !== undefined && secondName !== undefined
                ? `${firstName} ${secondName}`
                : '';

        return (
            <header>
                <div className="flex-horizontal header-wrapper">
                    <div className="header-logo flex-horizontal">
                        <img src={logo} alt="Febracis EAD" />
                        <span>EAD</span>
                    </div>
                    <div className="header-container flex-horizontal">
                        <NavItem
                            route={routes.USERS}
                            name="usuários"
                            path={location.pathname}
                            functionToCallInNavItem={() =>
                                changeRedirectToUsers({ withNewValue: false })
                            }
                        />
                        <NavItem
                            route={routes.COURSES}
                            name="cursos"
                            path={location.pathname}
                        />
                        <NavItem
                            route={routes.CLASSES}
                            name="turmas"
                            path={location.pathname}
                        />
                        <NavItem
                            route={routes.TCCS}
                            name="tccs"
                            path={location.pathname}
                        />
                        <NavItem
                            route={routes.QUESTIONS_DATABASE}
                            name="Testes Online"
                            path={location.pathname}
                            othersPathsToCompare={[
                                routes.QUESTIONS_DATABASE,
                                routes.TEMPLATE_TESTS,
                                routes.PERFORMED_TESTS,
                            ]}
                        />
                        <NavItem
                            route={routes.GLOBAL}
                            name="global"
                            path={location.pathname}
                        />
                        <NavItem
                            route={routes.ADMINS}
                            name="administradores"
                            path={location.pathname}
                        />
                        <NavItem
                            route={routes.TRAINERS}
                            name="instrutores"
                            path={location.pathname}
                        />
                        <div className="header-dropdown">
                            <div
                                className="header-avatar"
                                onClick={() =>
                                    this.setState({
                                        avatarExpanded: !avatarExpanded,
                                    })
                                }
                            >
                                <img
                                    className="avatar-img"
                                    src={photo}
                                    alt="avatar"
                                />
                            </div>
                            <div className="user-name" title={fullName}>
                                {fullName}
                            </div>
                            <div
                                className={
                                    'dropdown-content ' +
                                    (avatarExpanded ? 'show' : '')
                                }
                            >
                                <div className="arrow" />
                                <button
                                    type="button"
                                    className="button-logout"
                                    onClick={this.logout.bind(this)}
                                >
                                    Sair
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </header>
        );
    }
}

const NavItem = ({
    route,
    name,
    path,
    othersPathsToCompare = [],
    functionToCallInNavItem = () => {},
}) => (
    <div className="nav-item">
        <Link to={route}>
            <span
                className={`${
                    path === route ||
                    (othersPathsToCompare &&
                        othersPathsToCompare.includes(path))
                        ? 'selected'
                        : ''
                }`}
                onClick={functionToCallInNavItem}
            >
                {name.toUpperCase()}
            </span>
        </Link>
    </div>
);
const mapStateToProps = ({ login }) => {
    return {
        photoUrl: login.userInfo.photoUrl,
        firstName: login.userInfo.firstName,
        secondName: login.userInfo.secondName,
    };
};

export default connect(mapStateToProps, { logout, changeRedirectToUsers })(
    Header,
);



// WEBPACK FOOTER //
// ./src/components/header/header.js